import { apiQueryKey } from '@repo/api-codegen';
import { Button } from '@repo/foundations';
import { queryClient, useAuthUser, type ISecodaEntity } from '../../../api';
import entityDrawerStore from '../../EntityDrawer/store';

interface SetDescriptionActionProps {
	entity: ISecodaEntity;
}

export function SetDescriptionAction({ entity }: SetDescriptionActionProps) {
	const { isEditorOrAdminUser } = useAuthUser();

	const onClick = async () => {
		await entityDrawerStore.openEntityDrawerById(
			isEditorOrAdminUser,
			entity.id,
			undefined,
			() => {
				queryClient.invalidateQueries({
					queryKey: apiQueryKey('quality/{entity_id}/suggestions', {
						entity_id: entity.id,
					}),
				});
				queryClient.invalidateQueries({
					queryKey: apiQueryKey('quality/{entity_id}/suggestions', {
						entity_id: entity.parent!,
					}),
				});
			}
		);
	};

	return (
		<Button onClick={onClick} variant="primary">
			Set description
		</Button>
	);
}
